import React from "react";
import Const from './Const';
import Envir from './Envir';
import { messageModalWindow } from './Utils.js';
import { renderVideoPlayerWrapperU } from '../utils/VideoPlayerUtils.js';
import { isiPhone } from '../utils/AppUtils';
import { getNumericSafeAreaInsetsValues } from '../utils/CssUtils';

class ImageUpload extends React.Component {
	constructor(props) {
		super(props);
			this.state = {
				file: '',
				imagePreviewUrl: '',
				isError: false,
				playing : true,
				messageModal : false,
				header : '',
			    text : '',
				parent : null,
				videoFile : null
			};
	}

	disableElements() { 
		let imageDiv = document.getElementById('imageDiv');

		imageDiv.style.opacity = Const.REDUCED_OPACITY;
	}

	imagePreview(imageUrl) {
		let { imageParams } = this;
        let mediaUloadDimensions = this.getAvailableDimensionsForMediaUpLoad();
		let styleObj = {
			'--max-w': `${mediaUloadDimensions.width}px`, // 100% - possible value
			'--max-h': `${mediaUloadDimensions.height}px`,
			'--ratio': `${imageParams.maxWidth} / ${imageParams.maxHeight}`
		  };
		return (
			<div className="previewComponent">
				<div id="imageDiv" className="imgPreview">
					<div className="image-parent-create-post">
						<img alt="your upload" src={ imageUrl } className="img-fluid" style = { styleObj }/>
					</div>
				</div>
			</div>
		);
	}

	videoPreview(videoUrl, playing) {
		return (
			<div id="previewDiv" className="previewComponent">
				<div id="imageDiv" className="imgPreview">
					<div className="image-parent-create-post">
					  { renderVideoPlayerWrapperU(videoUrl, playing, false, this) }
					</div>
				</div>
			</div>
		);
	}

	defaultPreview() {
		
		return (
			<div className="previewComponent">
				<div id="imageDiv" className="imgPreview" >
				</div>
			</div>
		);
	}

	getAvailableDimensionsForMediaUpLoad() {
		let topPadding = 16 // because of margin-top: 1rem ;
		let bottomPadding = 10; // to make it safe
		let uploadImgOrVideoIckonBar = document.getElementById('uploadImgOrVideoIckonBarId');
		let textArea = document.getElementById('textArea');
		let main = document.getElementById('main');
		let insets = getNumericSafeAreaInsetsValues();
		let rect = uploadImgOrVideoIckonBar.getBoundingClientRect();
		let mainHeight = (Envir.iOS_APP && isiPhone()) ? window.innerHeight : main.offsetHeight;
		let availableHeight = mainHeight - (rect.top + 
											uploadImgOrVideoIckonBar.clientHeight + topPadding + bottomPadding +
											insets.safeAreaTop + insets.safeAreaBottom);
							  // the available height of the area below text area icons
		let availableWidth = textArea.offsetWidth;
		
		let videoUploadDimensions = {
									  width : availableWidth,
									  height : availableHeight
									}
		return videoUploadDimensions;
	}
	
	render() {
		let { imagePreviewUrl, videoPreviewUrl, playing } = this.state;

		return (
			<>
				{
					imagePreviewUrl && this.imagePreview(imagePreviewUrl)
				}

				{
					videoPreviewUrl && this.videoPreview(videoPreviewUrl, playing)
				}

				{
					!imagePreviewUrl && !videoPreviewUrl && this.defaultPreview()
				}
				
				<div>
					{
					messageModalWindow(this, this.state.header, this.state.text)
					}
				</div>
			</>
		)
	}
}

export default ImageUpload;